import { BaseProduct } from '../types/internal-types';

export class Utils {
  static findProductByPartialName(
    products: BaseProduct[],
    partialName: string,
  ): BaseProduct | undefined {
    return products.find(
      (product) => product.productCode.indexOf(partialName) > -1,
    );
  }
}
